<template>
  <div>
    <el-form :inline="true" :model="settlementSearchForm" class="user-search" size="mini">
      <!--<el-form-item label="">
        <el-select clearable v-model="selectedOperator" placeholder="选择运营商" @change="selectOperator">
          <el-option
            v-for="item in operators"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            style="width: 175px">
          </el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item>
        <el-cascader ref="cascader" :model="settlementSearchForm" filterable placeholder="选择运营商"
                     :options="operatorsTree"
                     v-model="operatorIds"
                     :show-all-levels="false"
                     :props="{ checkStrictly: true,expandTrigger: 'hover'}" @change="handChangeOperator"></el-cascader>
      </el-form-item>

      <el-form-item label="">
        <el-input v-model="settlementSearchForm.phone" placeholder="手机号" clearable style="width: 150px"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="settlementSearchForm.orderNo" placeholder="订单号" clearable style="width: 175px"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="settlementSearchForm.settlementNo" placeholder="结算单号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="settlementSearchForm.beginTime"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="开始时间"
                        style="width: 125px">
        </el-date-picker>
        <el-date-picker v-model="settlementSearchForm.endTime"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="结束时间"
                        style="width: 125px">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
        <el-button type="primary" icon="el-icon-search" @click="searchSettlementReport">查询</el-button>
        <el-button v-if="checkPermission(['bee:sett:settlementOrder:report:excel'])"
                   type="primary" icon="el-icon-download" @click="exportData">Excel导出</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" element-loading-text="拼命加载中" :data="settlementData" highlight-current-row border style="width: 100%;">
      <af-table-column prop="settlementNo" label="结算单号">
      </af-table-column>
      <af-table-column prop="operatorId" label="运营商" width="230px">
      </af-table-column>
      <af-table-column prop="orderNo" label="订单号">
      </af-table-column>
      <af-table-column prop="phone" label="手机号" width="130px">
      </af-table-column>
      <af-table-column prop="receAmt" label="应收金额(元)"width="110px">
      </af-table-column>
      <af-table-column prop="actualAmt" label="实收金额(元)"width="110px">
      </af-table-column>
      <af-table-column prop="noSettleAmt" label="未结清金额(元)" width="110px">
      </af-table-column>
      <af-table-column prop="settType" label="结算类型" width="150px">
      </af-table-column>
      <af-table-column prop="state" label="是否确认" width="100px">
      </af-table-column>
      <af-table-column prop="createTime" label="创建时间">
      </af-table-column>
    </el-table>
    <Pagination v-bind:child-msg="pageparam" @callFather="getSettlementReport"></Pagination>
  </div>
</template>

<script>
  import Pagination from '@/module/cardManage/component/Pagination.vue'
  import api from '@/module/dataCenter/api/report.js'
  import commonApi from '@/common/api/commonFromVuexApi.js'
  import comApi from '@/common/api/commonApi.js'

  export default {
    name: 'list',
    data() {
      return {
        operatorsTree: [],
        operatorIds: [],
        settlementData: [],
        settlementSearchForm:{},
        selectedOperator:'',
        operators: '',
        loading: false,
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },

      }
    },
    components: {
      Pagination
    },
    created() {
      this.loadOperators()
      this.getOperatorTree()
      this.searchSettlementReport()
    },
    methods: {
      getOperatorTree(){
        let params = JSON.stringify({});
        comApi.getOperatorsTree(params).then((res)=>{
          this.operatorsTree = res.data
        })
      },
      handChangeOperator(value){
        let operatorId = value && value.length > 0 ? value[value.length-1] : ''
        this.selectedOperator = operatorId
        this.$refs.cascader.dropDownVisible = false
      },
      //加载运营商列表
      loadOperators() {
        commonApi.getOperators().then((res) => {
          this.operators = res
        })
      },
      selectOperator() {
        api.stationList([this.selectedOperator]).then((res)=>{
          this.stations = res.data
        })
      },
      resetSearchForm() {
        this.settlementSearchForm = {}
        this.selectedOperator = ''
        this.operatorIds = []
        this.settlementReport()
      },
      searchSettlementReport(){
        this.getSettlementReport()
      },
      settlementReport(param){
        this.loading = true;
        api.getSettlementReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.settlementData = res.data.list
            this.loading = false;
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getSettlementReport(){
        this.pageparam.t = {
          operatorId :this.selectedOperator,
          phone : this.settlementSearchForm.phone===undefined?'':this.settlementSearchForm.phone,
          beginTime : this.settlementSearchForm.beginTime===undefined?'':this.settlementSearchForm.beginTime,
          endTime : this.settlementSearchForm.endTime===undefined?'':this.settlementSearchForm.endTime,
          settlementNo : this.settlementSearchForm.settlementNo===undefined?'':this.settlementSearchForm.settlementNo,
          orderNo : this.settlementSearchForm.orderNo===undefined?'':this.settlementSearchForm.orderNo
        }

        let param = Object.assign({}, this.pageparam)
        this.settlementReport(param)
      },
      async exportData(){
        let flag = false
        if (this.settlementSearchForm.beginTime == null || this.settlementSearchForm.endTime == null || this.settlementSearchForm.beginTime == '' || this.settlementSearchForm.endTime == 'min') {
          flag = false
        } else {
          let beginDate = new Date(this.settlementSearchForm.beginTime.substring(0,10))
          let endDate = new Date(this.settlementSearchForm.endTime.substring(0,10))
          let diffYear = endDate.getFullYear()-beginDate.getFullYear()
          let diffMonth = diffYear*12 + endDate.getMonth()-beginDate.getMonth()
          let diffDay = endDate.getDate()-beginDate.getDate()
          if (diffMonth<3 || (diffMonth == 3 && diffDay <=0 )) {
            flag = true
          }
        }
        //结算单
        if (flag) {
          let param = {
            phone : this.settlementSearchForm.phone===undefined?'':this.settlementSearchForm.phone,
            operatorId :this.selectedOperator,
            beginTime : this.settlementSearchForm.beginTime===undefined?'':this.settlementSearchForm.beginTime,
            endTime : this.settlementSearchForm.endTime===undefined?'':this.settlementSearchForm.endTime,
            settlementNo : this.settlementSearchForm.settlementNo===undefined?'':this.settlementSearchForm.settlementNo,
            orderNo : this.settlementSearchForm.orderNo===undefined?'':this.settlementSearchForm.orderNo
          }
          api.downSettlement(param).then((res)=>{
            if (res){
              this.downloadExcel(res,'结算单')
            }
          })
        } else {
          this.$message.error('请选择三个月之内数据导出')
        }
      },
      //下载excel,res为要导出的内容，name为文件名
      downloadExcel(res,name) {
        const blob = new Blob([res],{
          type: 'application/vnd.ms-excel;charset=utf-8'
        })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = name+'.xlsx'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/baobiao/settlementOrder/list.vue